import { SNIPPETS_CONFIG } from '@/constants/snippets/config';

export async function fetchResultListTeaser(): Promise<string> {
  const response = await fetch(SNIPPETS_CONFIG.RESULT_LIST_TEASER_URL, {
    signal: AbortSignal.timeout(SNIPPETS_CONFIG.TIMEOUT),
  });
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }
  return response.text();
}
